import { useCallback, useEffect, useRef, useState } from "react";
import { Button, Input, Typography, message } from "antd";
import copyToClipboard from "../../utils/copy";
import { downloadRetouchReviewPosterFromElement, ensureRetouchReviewPosterReady } from "../../utils/retouchReviewPoster";
import { getRetouchReviewCopy } from "../../utils/retouchReviewCopy";
import { useTranslation } from "../../i18n";
import RetouchReviewPoster from "./RetouchReviewPoster";
import "./RetouchReviewSharePanel.css";

const { Paragraph } = Typography;

function RetouchReviewSharePanel({ url, albumName, expiry }) {
    const { locale } = useTranslation();
    const copy = getRetouchReviewCopy(locale);
    const posterRef = useRef(null);
    const [posterReady, setPosterReady] = useState(false);
    const [posterError, setPosterError] = useState("");

    useEffect(() => {
        let cancelled = false;
        setPosterReady(false);
        setPosterError("");
        ensureRetouchReviewPosterReady().then(() => { if (!cancelled) setPosterReady(true); }).catch(() => { if (!cancelled) setPosterReady(true); });
        return () => { cancelled = true; };
    }, [url, albumName, expiry]);

    const copyLink = useCallback(async () => {
        try { await copyToClipboard(url); message.success(copy.posterLinkCopied); } catch { message.error(copy.loadFailed); }
    }, [copy.loadFailed, copy.posterLinkCopied, url]);

    const downloadPoster = useCallback(async () => {
        if (!posterRef.current) return;
        try { await downloadRetouchReviewPosterFromElement(posterRef.current, albumName); message.success(copy.posterDownload); }
        catch (error) { setPosterError(error.message || copy.posterFailed); message.error(copy.posterDownloadFailed); }
    }, [albumName, copy.posterDownload, copy.posterDownloadFailed, copy.posterFailed]);

    return <div className="retouch-review-share"><div className="retouch-review-share__url-row"><Input readOnly value={url} aria-label={copy.copyClient} /><Button type="primary" onClick={copyLink}>{copy.copyClient}</Button></div><div className="retouch-review-share__actions"><Button onClick={downloadPoster} disabled={!posterReady || Boolean(posterError)}>{copy.posterDownload}</Button></div><div className="retouch-review-share__poster-wrap">{!posterReady && <p>{copy.posterLoading}</p>}{posterError && <Paragraph type="danger">{posterError}</Paragraph>}<RetouchReviewPoster ref={posterRef} url={url} albumName={albumName} expiry={expiry} /></div></div>;
}

export default RetouchReviewSharePanel;
